import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export const sendEmailInvoice = async ({
  id,
}: {
  id: string
}): Promise<boolean> => {
  try {
    const sendResponse = await apiInstance.post<boolean>(
      ENDPOINTS.INVOICES_SERVICES.SEND_EMAIL_INVOICE(id),
    )

    return sendResponse.data
  } catch (getAllError) {
    const axiosError = getAllError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const exportInvoicesXmlZip = async ({
  ids,
  fileName,
}: {
  ids: number[]
  fileName: string
}): Promise<boolean> => {
  try {
    const getResponse = await apiInstance.get(
      ENDPOINTS.INVOICES_SERVICES.EXPORT_INVOICES_XML_ZIP,
      {
        params: {
          invoices_service_ids: ids.join(','),
        },
        responseType: 'arraybuffer',
      },
    )

    const a = document.createElement('a')
    const blob = new Blob([getResponse.data], {
      type: 'application/zip',
    })

    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = `${fileName}.zip`
    a.click()

    return getResponse.data
  } catch (getAllError) {
    const axiosError = getAllError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
